export const EARLIEST_DATE = '2009-01-01'
